var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "highlight-element highlight-content",
      class: [_vm.getContentAlignmentX, _vm.getContentDirection],
    },
    [
      _c(
        "div",
        {
          staticClass: "highlight-content-inner",
          class: _vm.getContentTextAlignment,
        },
        [
          _vm.imageUrl
            ? _c("div", { staticClass: "highlight-icon-container" }, [
                _c("img", {
                  staticClass: "highlight-icon",
                  class: _vm.getIconSize,
                  attrs: { src: _vm.imageUrl },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "highlight-text" }, [
            _vm.header.leadline
              ? _c("div", { staticClass: "highlight-leadline-container" }, [
                  _c("h4", { staticClass: "highlight-leadline" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.header.leadline) +
                        "\n        "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.header.title
              ? _c("div", { staticClass: "highlight-title-container" }, [
                  _c("h2", { staticClass: "highlight-title" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.header.title) + "\n        "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.header.description
              ? _c("div", {
                  staticClass: "highlight-description",
                  domProps: { innerHTML: _vm._s(_vm.header.description) },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.header.linkText
            ? _c(
                "div",
                { staticClass: "highlight-action" },
                [
                  _c("HighlightButton", {
                    attrs: {
                      "button-type": _vm.header.buttonType,
                      "button-style": _vm.header.buttonStyle,
                      icon: _vm.header.buttonIcon,
                      "icon-position": _vm.header.buttonIconPosition,
                      "button-size": _vm.header.buttonIconSize,
                      url: _vm.header.linkURL,
                      title: _vm.header.linkText,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }